import { ReactNode } from 'react';

import { LockIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';

export const GuidelineEditorHeader = ({ title }: { title: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <h2 className="relative flex items-center gap-1.5 text-lg leading-7 font-semibold text-muted-foreground">
      <InfoTooltip content={t('ai_agents.lock_icon_tooltip')}>
        <LockIcon className="absolute -left-6.5" size={12} />
      </InfoTooltip>
      {title}
    </h2>
  );
};
